// extracted by mini-css-extract-plugin
module.exports = {"title":"Reasons_title__2vrYp","item":"Reasons_item__3VYV3","items":"Reasons_items__37hao","label":"Reasons_label__1c_d2","wrap":"Reasons_wrap__2VSxU","info":"Reasons_info__1olRG"};